/* HOME PASSION · temel etkilesimler
   Karusel oklari kendi yumusak kaydirmamizi kullanir (hp-scroll.js). */
(function(){
  'use strict';

  function initArrows(root){
    (root||document).querySelectorAll('.hp-arrows').forEach(function(a){
      if(a.dataset.hpInit) return; a.dataset.hpInit='1';
      var vp=document.getElementById(a.dataset.for); if(!vp) return;
      var prev=a.querySelector('.prev'), next=a.querySelector('.next');

      function sync(){
        var max=vp.scrollWidth-vp.clientWidth;
        if(prev) prev.disabled = vp.scrollLeft <= 4;
        if(next) next.disabled = vp.scrollLeft >= max-4;
      }
      function go(dir){
        var step = (window.hpStep ? window.hpStep(vp) : 400) * dir;
        if(window.hpScrollBy) window.hpScrollBy(vp, step, 480);
        else vp.scrollLeft += step;
        setTimeout(sync, 560);
      }
      if(prev) prev.addEventListener('click',function(e){ e.preventDefault(); go(-1); });
      if(next) next.addEventListener('click',function(e){ e.preventDefault(); go(1); });
      vp.addEventListener('scroll',sync,{passive:true});
      [300,1200,2600].forEach(function(ms){ setTimeout(sync,ms); });
    });
  }

  /* Olcu cipleri slideri */
  function initSwatches(root){
    (root||document).querySelectorAll('.hp-pc-sw').forEach(function(row){
      if(row.dataset.hpInit) return; row.dataset.hpInit='1';
      var track=row.querySelector('.hp-swt'); if(!track) return;
      var prev=row.querySelector('.prev'), next=row.querySelector('.next');
      var i=0, step=30, total=track.children.length, vis=4;
      function upd(){
        if(window.hpScrollTo) window.hpScrollTo(track, i*step, 300);
        else track.scrollLeft=i*step;
        if(prev) prev.disabled=i<=0; if(next) next.disabled=i>=total-vis;
      }
      if(prev) prev.addEventListener('click',function(e){e.preventDefault();i=Math.max(0,i-1);upd()});
      if(next) next.addEventListener('click',function(e){e.preventDefault();i=Math.min(Math.max(0,total-vis),i+1);upd()});
      track.addEventListener('click',function(e){
        if(!e.target.classList.contains('hp-sw'))return;
        row.querySelectorAll('.hp-sw').forEach(function(s){s.classList.remove('on')});
        e.target.classList.add('on');
      });
    });
  }

  window.hpAddToCart=function(items,btn){
    var orig=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='Ekleniyor...'}
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:items})})
      .then(function(r){return r.json()})
      .then(function(){
        if(btn){btn.textContent='Sepete eklendi';setTimeout(function(){btn.textContent=orig;btn.disabled=false},1600)}
        document.dispatchEvent(new CustomEvent('hp:cart-added'));
      })
      .catch(function(){if(btn){btn.textContent='Hata, tekrar dene';btn.disabled=false}});
  };

  function boot(root){initArrows(root);initSwatches(root)}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){boot()})}
  else{boot()}
  document.addEventListener('shopify:section:load',function(e){boot(e.target)});
  window.hpBoot=boot;
})();
